export namespace StatementConstant {
  export const FILE_EXTENSION = '.pdf';
}
